import React, { useState } from "react";
import CalculatorCard from "../../components/CalculatorCard";
import PageSeo from "../../components/PageSeo";
import { Helmet } from "react-helmet-async";

export default function TripCalculator() {
  const [distance, setDistance] = useState("");
  const [speed, setSpeed] = useState("");
  const [time, setTime] = useState(null);

  const calculateTrip = () => {
    const d = Number(distance);
    const s = Number(speed);

    if (!d || !s) return;

    const t = d / s;
    setTime(t.toFixed(2));
  };

  const shareOnWhatsApp = () => {
    const text = encodeURIComponent(`Check my calculation result: Travel Time ${time} hours | MotoHub India https://motohubindia.com`);
    const url = window.innerWidth < 768 
      ? `whatsapp://send?text=${text}` 
      : `https://web.whatsapp.com/send?text=${text}`;
    window.open(url, '_blank');
  };

  const downloadPDF = () => {
    const el = document.getElementById('calculator-result');
    const original = document.title;
    document.title = 'MotoHub-Calculation-Result';
    window.print();
    document.title = original;
  };

  return (
    <>
      <Helmet>
        <title>Bike Trip Time Calculator India | Travel Planner | MotoHub India</title>
        <meta
          name="description"
          content="Calculate bike trip time in India using distance and speed. Plan motorcycle rides and travel schedules easily."
        />
        <meta
          name="keywords"
          content="bike trip calculator India, motorcycle travel time, ride planner India, bike route time calculator"
        />
        <link rel="canonical" href="https://motohubindia.com/calculator/trip" />
        <meta property="og:title" content="Bike Trip Calculator | MotoHub India" />
        <meta property="og:description" content="Plan your motorcycle travel time easily." />
        <meta property="og:url" content="https://motohubindia.com/calculator/trip" />
      </Helmet>

      <div style={{ padding: "30px" }}>
        <PageSeo
          title="Bike Trip Calculator India | MotoHub"
          description="Estimate bike travel time easily."
          path="/calculator/trip"
        />

        <CalculatorCard title="Trip Time Calculator">
          <div style={seoBox}>
            <h2>Bike Trip Time Calculator India</h2>
            <p style={seoText}>
              Use MotoHub India trip calculator to estimate travel time for your motorcycle rides. 
              Enter distance and average speed to plan your journey efficiently.
            </p>
            <p style={seoText}>
              This tool helps bikers plan long trips, calculate ride duration, and manage travel schedules across cities and highways.
            </p>
          </div>

          <input
            placeholder="Distance (km)"
            value={distance}
            onChange={(e) => setDistance(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Speed (km/h)"
            value={speed}
            onChange={(e) => setSpeed(e.target.value)}
            style={inputStyle}
          />

          <button style={buttonStyle} onClick={calculateTrip}>
            Calculate Time
          </button>

          <div id="calculator-result">
            {time && (
              <>
                <h3 style={{ marginTop: "20px" }}>
                  Travel Time: {time} hours
                </h3>
                <button onClick={shareOnWhatsApp} 
                  className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm">
                  Share on WhatsApp
                </button>
                <button onClick={downloadPDF}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm">
                  Download PDF
                </button>
              </>
            )}
          </div>
        </CalculatorCard>
      </div>
    </>
  );
}

// Styles
const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "1px solid #333",
  background: "#1a1a1a",
  color: "#fff"
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "10px",
  border: "none",
  background: "linear-gradient(90deg, #ff4d00, #ff7a00)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px"
};

const seoBox = {
  marginBottom: "20px",
  background: "#111",
  padding: "15px",
  borderRadius: "10px",
  border: "1px solid #222"
};

const seoText = {
  color: "#aaa",
  lineHeight: "1.6",
  marginTop: "8px"
};